"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnexionInstructionsWithBlocks = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const rn_css_1 = require("rn-css");
const base_ui_theme_spacing_1 = require("@unboared/base-ui.theme.spacing");
const base_ui_responsive_sizes_1 = require("@unboared/base-ui.responsive.sizes");
const base_ui_theme_themes_1 = require("@unboared/base-ui.theme.themes");
const base_ui_media_video_1 = require("@unboared/base-ui.media.video");
const base_ui_text_heading_1 = require("@unboared/base-ui.text.heading");
const _1 = require(".");
const design_connexion_connexion_view_1 = require("@unboared/design.connexion.connexion_view");
const Block = ({ style, children }) => {
    // Get utils for responsiveness
    const theme = (0, rn_css_1.useTheme)();
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    const currentTheme = theme || base_ui_theme_themes_1.unboaredTheme.default;
    return (react_1.default.createElement(react_native_1.View, { style: [{
                borderRadius: normalize(base_ui_theme_spacing_1.space.large),
                backgroundColor: currentTheme.backgroundColor,
                margin: normalize(base_ui_theme_spacing_1.space.medium),
                padding: normalize(base_ui_theme_spacing_1.space.large),
                alignItems: 'center',
                justifyContent: 'center'
            }, style] }, children));
};
const VideoBlock = ({ style, urlVideo }) => {
    // Get utils for responsiveness
    return (react_1.default.createElement(Block, { style: style },
        react_1.default.createElement(react_native_1.View, { style: { flex: 0.2, justifyContent: 'center' } },
            react_1.default.createElement(base_ui_text_heading_1.Heading, { type: 'h2', tx: "screen.connexionPage.title", style: { textAlign: 'center' } })),
        react_1.default.createElement(react_native_1.View, { style: { flex: 0.7 } },
            react_1.default.createElement(base_ui_media_video_1.Video, { style: {
                    height: '100%',
                    width: '100%'
                }, source: urlVideo || "https://unboared.com/wp-content/uploads/2022/08/Unboared_Ingame_Video.mp4" })),
        react_1.default.createElement(react_native_1.View, { style: { flex: 0.1 } })));
};
const QrCodeBlock = ({ roomID, url, style }) => {
    // Get utils for responsiveness
    const { normalize } = (0, base_ui_responsive_sizes_1.useNormalize)();
    return (react_1.default.createElement(Block, { style: style },
        react_1.default.createElement(base_ui_text_heading_1.Heading, { type: 'h3', style: { marginBottom: normalize(base_ui_theme_spacing_1.space.small), textAlign: 'center' }, tx: "screen.connexionPage.qrTitle" }),
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(design_connexion_connexion_view_1.QRCodeView, { roomID: roomID, url: url, size: 120 }))));
};
const PlayersBlock = ({ connectedPlayers, masterID, style }) => {
    return (react_1.default.createElement(Block, { style: style },
        react_1.default.createElement(_1.ConnexionIntructionsInfosPlayers, { connectedPlayers: connectedPlayers, masterID: masterID })));
};
const ConnexionInstructionsWithBlocks = ({ style, roomID, url, connectedPlayers, masterID, urlVideo, test }) => {
    return (react_1.default.createElement(react_native_1.View, { style: [{ flex: 1 }, style] },
        react_1.default.createElement(react_native_1.View, { style: { flex: 0.6, flexDirection: 'row', alignSelf: 'stretch' } },
            react_1.default.createElement(VideoBlock, { urlVideo: urlVideo, style: { flex: 0.6 } }),
            react_1.default.createElement(QrCodeBlock, { style: { flex: 0.4 }, roomID: roomID, url: url })),
        connectedPlayers.length > 0 &&
            react_1.default.createElement(react_native_1.View, { style: { flex: 0.4, alignSelf: 'stretch' } },
                react_1.default.createElement(PlayersBlock, { style: { flex: 1, justifyContent: 'space-between' }, connectedPlayers: connectedPlayers, masterID: masterID }))));
};
exports.ConnexionInstructionsWithBlocks = ConnexionInstructionsWithBlocks;
//# sourceMappingURL=connexion_instructions_with_blocks.js.map